import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: 'Is this a physical book or a digital download?',
    answer: "It's a digital PDF you download instantly. No shipping, no waiting. You can read it on any device or print the pages you need."
  }, {
    question: 'How long is it?',
    answer: "The Premium Edition is 60–90 pages, depending on how you count the printables. It's designed to be read in one sitting and used immediately."
  }, {
    question: 'Can I print the worksheets?',
    answer: "Yes — that's the whole point. The Legacy Map, Decision Rules Sheet, Family Meeting Agenda, and Last-Week Checklist are all designed to be printed and put on your wall or fridge."
  }, {
    question: 'What if my wife wants to be involved?',
    answer: 'Great — the Family Sorting Meeting section is built for exactly that. It gives both of you a structured 30-minute format so decisions happen without debate.'
  }, {
    question: "I'm not tech-savvy. Will I be able to use this?",
    answer: "If you can open an email and click a link, you can use this. It's a simple PDF — no apps, no accounts, no passwords."
  }, {
    question: "What if it doesn't work for me?",
    answer: "If you open it and feel it's not right for your situation, email us and we'll make it right. No hoops."
  }];
  return <section className="py-20 px-6 bg-[#FAFAF7] border-t border-[#D4C5A9]/30" data-id="element-145">
      <div className="max-w-[720px] mx-auto" data-id="element-146">
        <div className="text-center mb-12 fade-in-up" data-id="element-147">
          <h2 className="text-3xl font-serif font-bold text-[#2B4257] mb-4" data-id="element-148">
            Common Questions
          </h2>
        </div>

        <div className="space-y-4 fade-in-up delay-100" data-id="element-149">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-150" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-lg border border-[#D4C5A9]/30 overflow-hidden transition-all duration-200 hover:shadow-md" data-id="element-151">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" aria-expanded={isOpen} data-id="element-152">
        <span className="font-bold text-[#2B4257] text-lg pr-8" data-id="element-153">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-[#6B9B8A] flex-shrink-0 transition-transform duration-300 ${isOpen ? 'transform rotate-180' : ''}`} data-id="element-154" />
      </button>

      <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-155">
        <p className="text-[#5A5A5A] leading-relaxed text-base border-t border-[#D4C5A9]/10 pt-4" data-id="element-156">
          {answer}
        </p>
      </div>
    </div>;
}